module.exports = __webpack_public_path__ + "static/media/divineprop.4ae9544d.png";